import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from '@services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
export interface tvStreamUrlType {
  betradar_id: string;
  videoURL: string;
}

export type liveStreamData = { videoUrl: string; matchId: number };
@Injectable({
  providedIn: 'root',
})
export class LiveStreamService {
  private tvStreamingSubscription: Subscription;
  private liveDataSubscription: Subscription;
  public tvStreamUrlList: tvStreamUrlType[] = [];
  public tvStreamUrlListListener: EventEmitter<any> = new EventEmitter();
  public liveTvList: any[];
  public upComingTvList: liveStreamData[];
  public betradarUpComingTvList: liveStreamData[];
  public liveTvListListener: EventEmitter<liveStreamData[]> = new EventEmitter();
  public upComingTvListListener: EventEmitter<liveStreamData[]> = new EventEmitter();
  public betradarUpcomingLiveTvListener: EventEmitter<liveStreamData[]> = new EventEmitter();
  public closeTvStreamListener: EventEmitter<any> = new EventEmitter();
  public isOnTvButton = false;
  public isOnTvButtonListener: EventEmitter<any> = new EventEmitter();
  liveStreamData:
    | {
        videoUrl: string;
        awayTeam: string;
        homeTeam: string;
        id: string | number;
      }
    | undefined;
  liveStreamDataListener: EventEmitter<any> = new EventEmitter();
  liveStreamLiveEvent = false;
  constructor(private _ApiService: ApiService, private domSanitizer: DomSanitizer) {}

  setIsOnTvButton(x: boolean) {
    if (environment.isLiveStream && this.isOnTvButton !== x) {
      this.isOnTvButton = x;
      this.isOnTvButtonListener.emit();
    }
  }

  resetLiveStreamUrl() {
    this.liveStreamData = undefined;
    this.liveStreamDataListener.emit(undefined);
  }

  setLiveStreamUrl(item: any) {
    if (!this.liveStreamLiveEvent) {
      const isSameStream = this.liveStreamData && this.liveStreamData.id === item?.BetradarMatchId;
      const a = this.liveTvList.find(x => x.matchId === item?.BetradarMatchId);

      if (a) {
        if (isSameStream) {
          // Aynı yayına tıklanmışsa, yayını kapat
          this.closeTvStreamListener.emit();
        } else {
          // Farklı bir yayına tıklanmışsa, önce mevcut yayını kapat
          if (this.liveStreamData) {
            this.closeTvStreamListener.emit();
          }

          this._ApiService.postLiveStreamURL(a.videoUrl.betradar_id.toString(), true).then(r => {
            this.liveStreamData = {
              videoUrl: r.Data.Url,
              awayTeam: item?.AwayTeam,
              homeTeam: item?.HomeTeam,
              id: item?.BetradarMatchId,
            };
            this.liveStreamDataListener.emit({
              videoUrl: r.Data.Url,
              awayTeam: item?.AwayTeam,
              homeTeam: item?.HomeTeam,
              id: item?.BetradarMatchId,
            });
          });
        }
      }
    }
  }

  liveEventDetailsSetTvUrl(paramId: string | number, videoUrl: any, callback: (newVideoUrl: any) => void) {
    if (paramId && Array.isArray(this.liveTvList) && this.liveTvList.length > 0) {
      let a = this.liveTvList.find(x => x.matchId === Number(paramId));
      if (a) {
        this._ApiService
          .postLiveStreamURL(a.videoUrl.betradar_id.toString(), true)
          .then(r => {
            const newVideoUrl = r.Data.Url;
            callback(newVideoUrl);
          })
          .catch(error => {
            console.error('Error fetching video URL:', error);
            callback('none');
          });
      } else {
        callback('none');
      }
    } else {
      callback('waiting');
    }
  }

  matchRowSearchVideoUrl(id: number): boolean {
    return this.liveStreamData && this.liveStreamData.id === id;
  }

  videoUrlSearch(data: any): liveStreamData | null {
    if (Array.isArray(this.liveTvList) && this.liveTvList.length > 0) {
      const a = this.liveTvList.find((i: any) => i?.matchId === data?.BetradarMatchId);
      if (a) {
        return a;
      } else {
        return null;
      }
    }
  }

  preVideoUrlSearch(data: any): liveStreamData | null {
    if (Array.isArray(this.upComingTvList) && this.upComingTvList.length > 0) {
      const a = this.upComingTvList.find((i: any) => i?.matchId === data?.BetradarMatchId);
      if (a) {
        return a;
      } else {
        return null;
      }
    }
  }

  setBetradarLiveData(v: Array<any>) {
    if (environment.isLiveStream) {
      const urlList = [];
      if (Array.isArray(this.tvStreamUrlList) && this.tvStreamUrlList.length > 0) {
        v.forEach(i => {
          const a = this.createdBetradarLiveStreamUrl({
            tvStreamUrlList: this.tvStreamUrlList,
            BetradarMatchId: i.BetradarMatchId,
          });
          if (a) {
            urlList.push(a);
          }
        });
      }

      this.liveTvList = urlList;
      this.liveTvListListener.emit(urlList);
    }
  }

  setLiveData(v: Array<any>) {
    if (environment.isLiveStream) {
      const urlList = [];
      if (Array.isArray(this.tvStreamUrlList) && this.tvStreamUrlList.length > 0) {
        v.forEach(i => {
          const matchedUrl = this.tvStreamUrlList.find((url: any) => url.betradar_id?.includes(i.BetradarMatchId));

          if (matchedUrl) {
            urlList.push({
              videoUrl: matchedUrl,
              matchId: i.BetradarMatchId,
            });
          }
        });
      }
      this.liveTvList = urlList;
      this.liveTvListListener.emit(urlList);
    }
  }

  setBetradarUpComingTvData(v: Array<any>) {
    if (environment.isLiveStream) {
      const urlList = [];
      if (Array.isArray(this.tvStreamUrlList) && this.tvStreamUrlList.length > 0) {
        v.forEach(i => {
          const a = this.createdBetradarLiveStreamUrl({
            tvStreamUrlList: this.tvStreamUrlList,
            BetradarMatchId: i.BetradarMatchId,
          });
          if (a) {
            urlList.push(a);
          }
        });
      }

      this.betradarUpComingTvList = urlList;
      this.betradarUpcomingLiveTvListener.emit(urlList);
    }
  }

  setUpComingTvData(v: Array<any>) {
    if (environment.isLiveStream) {
      const urlList = [];
      if (Array.isArray(this.tvStreamUrlList) && this.tvStreamUrlList.length > 0) {
        v.forEach(i => {
          const a = this.createdLiveStreamUrl({
            tvStreamUrlList: this.tvStreamUrlList,
            BetradarMatchId: i.BetradarMatchId,
            MapMatchId: i.MapMatchId,
          });
          if (a) {
            urlList.push(a);
          }
        });
      }

      this.upComingTvList = urlList;
      this.upComingTvListListener.emit(urlList);
    }
  }

  setTvStreamingList(data: any) {
    let rebuildData;

    rebuildData = data.reduce((acc, arr) => {
      const betradarId = arr;
      acc.push({
        betradar_id: betradarId,
        videoURL: arr,
      });

      return acc;
    }, []);
    if (rebuildData && rebuildData.length > 0) {
      this.tvStreamUrlList = rebuildData;
      this.tvStreamUrlListListener.emit(rebuildData);
    }
  }

  tvStreamingTimerAction() {
    this.tvStreamingSubscription = timer(0, 1000 * 60)
      .pipe(switchMap(() => this._ApiService.getLiveStreamEventsList()))
      .subscribe(data => {
        if (data && data.Data && data.Data.length > 0) {
          this.setTvStreamingList(data);
        } else {
          if (data && Array.isArray(data) && data.length > 0) {
            this.setTvStreamingList(data);
          }
        }
      });
  }

  private mapMatchIdControl = ({ matchId, mapMatchId }: { matchId: number; mapMatchId: string }): string => {
    if (typeof matchId === 'number' && matchId < 0) {
      return mapMatchId;
    }
    return matchId.toString();
  };

  private createdLiveStreamUrl = ({
    tvStreamUrlList,
    BetradarMatchId,
    MapMatchId,
  }: {
    tvStreamUrlList: tvStreamUrlType[];
    BetradarMatchId: number;
    MapMatchId: string;
  }): liveStreamData | null => {
    const tvUrlObject: tvStreamUrlType | number = tvStreamUrlList.find(
      (x: tvStreamUrlType) =>
        x.betradar_id ===
        this.mapMatchIdControl({
          matchId: BetradarMatchId,
          mapMatchId: MapMatchId,
        })
    );

    if (tvUrlObject?.videoURL) {
      return {
        videoUrl: tvUrlObject.videoURL,
        matchId: BetradarMatchId,
      };
    } else {
      return null;
    }
  };

  private createdBetradarLiveStreamUrl = ({ tvStreamUrlList, BetradarMatchId }: { tvStreamUrlList: tvStreamUrlType[]; BetradarMatchId: number }): liveStreamData | null => {
    const tvUrlObject: tvStreamUrlType | number = tvStreamUrlList.find((x: tvStreamUrlType) => x.betradar_id.toString() === BetradarMatchId.toString());
    if (tvUrlObject?.videoURL) {
      return {
        videoUrl: tvUrlObject.videoURL,
        matchId: BetradarMatchId,
      };
    } else {
      return null;
    }
  };
}
